import React from "react";
import "./ContactUsPage.css";
import insta_qr from '../../assets/qr/instagram_qr.png';
import linkedin_qr from '../../assets/qr/linkedin_qr.png';
// import fb_qr from '../../assets/qr/facebook_qr.png';
import wb_qr from '../../assets/qr/whatsapp_qr.png';

export default function ContactUsPage() {
    return (
        <div className="contact-us-container">
            <h1>Contact Us</h1>
            <div className="contact-us-content">
                <div className="contact-us-info">
                    <p><span>Email: </span>adoni@iitd.ac.in</p>
                    <p><span>For school and college visits: </span>acadoutreach@admin.iitd.ac.in</p>
                </div>
                <div className="follow-us-info">
                    <h1>Follow Us</h1>
                    <div className="images-container">
                        <div className="qr-image">
                            <img src={insta_qr} alt="" />
                            <span>Instagram</span>
                        </div>  
                        <div className="qr-image">
                            <img src={wb_qr} alt="" />
                            <span>WhatsApp</span>
                        </div>
                        <div className="qr-image">
                            <img src={linkedin_qr} alt="" />
                            <span>LinkedIn</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}